import * as React from "react";
import {Dialog, Theme, Typography, WithStyles, withStyles} from "@material-ui/core";
//@ts-ignore
import CircularIndeterminate
    from 'hcla-web-frontend-primitives/app/components/primitives/Progress/CircularIndeterminate';

import {injectIntl, WrappedComponentProps} from "react-intl";
import createStyles from "@material-ui/core/styles/createStyles";
// @ts-ignore
import ReactTable, {Column} from "react-table";
import 'react-table/react-table.css';
//@ts-ignore
import CopyToClipboardChip from "hcla-web-frontend-primitives/app/components/primitives/Chips/CopyToClipboardChip";
import {QRCutsetListJSON, QRResultDataJSON,} from "../Quantification/QuantificationResultJSON";
import CutsetItemChip, {CutsetItemChipProps} from "./Chips/CutsetItemChip";
import {QCTypeParams} from "../Quantification/QuantificationConfigurationJSON";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import RiskCurvesContent from "../../Generic/RiskCurvesContent";
import NodeLabel from "./NodeLabel/NodeLabel";
const _ = require('lodash');

const styles = (theme: Theme) => createStyles({
    root: {
        height: '100%',
        width: '100%',
        margin: '0',
        overflow: 'auto',
        padding: '0',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.text.primary,
    },
    subcomponent: {
        padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
        background: 'rgba(0, 0, 0, 0.03)',
    },
    tabContainer: {
        width: '100%',
        height: '100%',
    },
    tabsRoot: {
        height: 'calc(100% - 48px)',
        '& .react-swipeable-view-container': {
            height: '100%',
        },
    },
    cutsetChip: {
        margin: `0px ${theme.spacing(0.5)}px`,
        flexDirection: 'row',
    },
    cutsetRowItem: {
        flexDirection: 'row',
    },
    cutsetRow: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    rowItem: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    plotContainer: {
        width: "max-content",
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    successBG: {
        backgroundColor: '#81c784',
        '&:hover': {
            backgroundColor: '#81c784'
        }
    },
    failureBG: {
        backgroundColor: '#e57373',
        '&:hover': {
            backgroundColor: '#e57373'
        }
    },
    defaultBG: {
        backgroundColor: 'lightgray',
        '&:hover': {
            backgroundColor: 'lightgray'
        }
    },
});

export interface CutsetComparisonViewProps extends WithStyles<typeof styles>, WrappedComponentProps {
    resultDataA: QRResultDataJSON;
    resultDataB: QRResultDataJSON;
    type: QCTypeParams;
    noDataText?: JSX.Element;
    loadingText?: JSX.Element;
    loading?: boolean;
    cutsetItemChip?: any;
    riskCurves?: { [key: string]: any }
}

interface State {
    dialog: any;
}

const isCutsetEmpty = (data: QRResultDataJSON): boolean => {
    try {
        const {sequences, label_map} = data;
        return Object.keys(sequences).length <= 0 || Object.keys(label_map).length <= 0;
    } catch (e) {
        return true;
    }
};

const wrapHOCItemChip = (WrappedCutsetItemChip: any, props: CutsetItemChipProps) => <WrappedCutsetItemChip {...props} />

class CutsetComparisonView extends React.Component<CutsetComparisonViewProps, State> {
    public static defaultProps = {
        noDataText: <Typography variant="h5" align="center">Quantification Results Unavailable</Typography>,
        loadingText: <CircularIndeterminate size={80} color="secondary"/>,
        cutsetItemChip: (props: CutsetItemChipProps) => <CutsetItemChip {...props} />,
        loading: false,
    };

    constructor(props: CutsetComparisonViewProps) {
        super(props);
        this.state = {
            dialog: null
        }
    }

    private makeAccessor = (param, comparison: {before: any, after: any}, type) => {
        const {classes} = this.props
        let chip = <CopyToClipboardChip color={"secondary"} label={param.toExponential(3)} classes={{ root: classes.fullWidth }} />
        if(param !== null || param !== undefined){
            let colorParam = classes.successBG; //greater than / success
            if(type === "Success" && comparison.before < comparison.after){
                colorParam = classes.failureBG;
            }
            if(type === "Failure" && comparison.before > comparison.after){
                colorParam = classes.failureBG;
            }
            if(comparison.before == comparison.after){
                colorParam = classes.defaultBG;
            }

            chip = <CopyToClipboardChip label={param.toExponential(3)} classes={{ root: colorParam }} />
        }

        return <div className={classes.rowItem}>{chip}</div>;
    }

    private getColor = (param, compParam, type) => {
        let colorParam = '#4CAF50'; //greater than / success
        if (param !== null || param !== undefined) {
            if(type === "Success" && param < compParam){
                colorParam = '#F44336';
            }
            if(type === "Failure" && param > compParam){
                colorParam = '#F44336';
            }
            if(param == compParam){
                colorParam = 'darkgray';
            }
        }

        return colorParam;
    }


    public getCutsetColumns = (): Column<[string, QRCutsetListJSON]>[] => {
        const {resultDataA, resultDataB, intl, cutsetItemChip, classes: {cutsetRow, rowItem, cutsetRowItem, cutsetChip}} = this.props;

        return ([
            {
                id: 'ranking',
                maxWidth: 40,
                Cell: ( d: any ) => {
                    return <Typography>{d.original.after.ranking}</Typography>;
                },
                Header: <Typography variant="h6"
                                    align="center">{intl.formatMessage({id: 'FaultTreeResultView.Columns.Header.ranking'})}</Typography>,
            },
            {
                id: 'minimalCut',
                Header: <Typography variant="h6"
                                    align="center">{intl.formatMessage({id: 'FaultTreeResultView.Columns.Header.minimalCut'})}</Typography>,
                accessor: (d: any) => (
                    <div className={cutsetRow}>
                        <div className={cutsetRowItem}>
                            {
                                d.after.cutset.map((x: string) => wrapHOCItemChip(cutsetItemChip, {
                                    name: x,
                                    map: resultDataA.label_map
                                }))
                            }
                        </div>
                    </div>
                ),
            },
            {
                id: 'probability_before',
                maxWidth: 180,
                Header: <Typography variant="h6"
                                    align="center">{intl.formatMessage({id: 'FaultTreeResultView.Columns.Header.probability'})} Before</Typography>,
                accessor: (d: any) => this.makeAccessor(d.before.probability, {before: d.after.probability, after: d.before.probability}, NodeLabel.buildWithDefaults(resultDataA.label_map, d.endstate).label.name),
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && this.getColor(rowInfo.original.after.probability, rowInfo.original.before.probability, NodeLabel.buildWithDefaults(resultDataA.label_map, rowInfo.original.endstate).label.name)
                        },
                    };
                },
            },
            {
                id: 'probability_after',
                maxWidth: 180,
                Header: <Typography variant="h6"
                                    align="center">{intl.formatMessage({id: 'FaultTreeResultView.Columns.Header.probability'})} After</Typography>,
                accessor: (d: any) => this.makeAccessor(d.after.probability, {before: d.after.probability, after: d.before.probability}, NodeLabel.buildWithDefaults(resultDataA.label_map, d.endstate).label.name),
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && this.getColor(rowInfo.original.after.probability, rowInfo.original.before.probability, NodeLabel.buildWithDefaults(resultDataA.label_map, rowInfo.original.endstate).label.name)
                        },
                    };
                },
            },
        ]);
    };

    public getEndStateColumns = (): Column<[string, QRCutsetListJSON]>[] => {
        const {intl, resultDataA, resultDataB, type, classes: {rowItem}, riskCurves} = this.props;

        //combine label maps
        const labelMap = Object.assign(resultDataA.label_map, resultDataB.label_map);

        const nameColumn = {
            id: 'name',
            Header: <Typography variant="h6"
                                align="center">{intl.formatMessage({id: 'EventTreeResultView.Columns.endStates'})}</Typography>,
            accessor: (d) =>{   const variantParam = (!d["resultA"] || !d["resultB"])? "outlined":"default";
                                return <CutsetItemChip variant={variantParam} map={labelMap} name={d.endstate}/>},
        };

        /*function makeAccessor(target) {
            let acc;
            switch (type) {
                case QCTypeParams.POINT_ESTIMATE:
                case QCTypeParams.POINT_ESTIMATE_AT_FIXED_TIME:
                    acc = (d): JSX.Element => <div className={rowItem}>
                        d[target]?<CopyToClipboardChip color="secondary" label={(d[target]).toExponential(3)}/>
                        : <CopyToClipboardChip color="secondary" label={"N/A"}/>
                    </div>;
                    break;

                case QCTypeParams.UNCERTAINTY:
                case QCTypeParams.UNCERTAINTY_AT_FIXED_TIME:
                    acc = (d): JSX.Element => <UncertainProbabilityChip data={d[target]}
                                                                        map={resultDataA.label_map}
                                                                        name={d[0]}/>;
                    break;

                case QCTypeParams.TIME_TO_FAILURE_CDF:
                    acc = (d): JSX.Element => <PointEstimateTTFChip data={d[target].result} map={resultDataA.label_map}
                                                                    name={d.endstate}/>;
                    break;

                case QCTypeParams.TIME_TO_FAILURE_CDF_WITH_UNCERTAINTY:
                    acc = (d): JSX.Element => <UncertainTTFChip data={d[target].result} map={resultDataA.label_map}
                                                                name={d.endstate}/>;
                    break;

                default:
                    acc = (d): JSX.Element => <CopyToClipboardChip color="secondary"
                                                                   label={d[target]}/>;
                    break;
            }

            return acc;
        }*/

        const probColumnA = {
            id: 'probA',
            maxWidth: 240,
            Header: <Typography variant="h6"
                                align="center">{intl.formatMessage({id: 'FaultTreeResultView.Columns.Header.probability'})} Before</Typography>,
            accessor: (d) => this.makeAccessor(d["resultA"], {before: d["resultB"], after: d["resultA"]}, NodeLabel.buildWithDefaults(resultDataA.label_map, d.endstate).label.name),
            getProps: (state, rowInfo, column) => {
                return {
                    style: {
                        background: rowInfo && this.getColor(rowInfo.original.resultB, rowInfo.original.resultA, NodeLabel.buildWithDefaults(resultDataA.label_map, rowInfo.original.endstate).label.name)
                    },
                };
            },
        };


        const probColumnB = {
            id: 'probB',
            maxWidth: 240,
            Header: <Typography variant="h6"
                                align="center">{intl.formatMessage({id: 'FaultTreeResultView.Columns.Header.probability'})} After</Typography>,
            accessor: (d) => this.makeAccessor(d["resultB"], {before: d["resultB"], after: d["resultA"]}, NodeLabel.buildWithDefaults(resultDataA.label_map, d.endstate).label.name),
            getProps: (state, rowInfo, column) => {
                return {
                    style: {
                        background: rowInfo && this.getColor(rowInfo.original.resultB, rowInfo.original.resultA, NodeLabel.buildWithDefaults(resultDataA.label_map, rowInfo.original.endstate).label.name)
                    },
                };
            },
        };

        const showRiskCurvesColumn = riskCurves ? true : false;
        const riskCurvesColumn = {
            id: "risk curves",
            maxWidth: 120,
            Header: <Typography variant="h6" align="center">Risk Curves</Typography>,
            accessor: "",
            Cell: (rowInfo: any) => {
                const title = resultDataA.label_map[rowInfo.original[0]].label.name;
                const probability = rowInfo.original[1].result;
                return (
                    <Button
                        variant={"outlined"}
                        color={"primary"}
                        fullWidth
                        onClick={() => this.openRiskCurveDialog(title, probability, rowInfo.original)}
                    >
                        View
                    </Button>
                );
            },
            show: showRiskCurvesColumn
        };

        return [nameColumn, probColumnA, probColumnB];
    };

    private openRiskCurveDialog = (title: string, probability: number, endState: any) => {
        const {classes, riskCurves} = this.props;
        if (!riskCurves) return;
        let noRiskCurveEndStates = ["SQ_CtOjx7KCn.3554", "SQ_hPdsHmVU_E.3554", "SQ_m0TfKyW5Y.3554", "SQ_bN3bPNV0qt.3554", "SQ_BU4E1hvvlA.3554", "SQ_OibYL5Vv4e.3554"];
        const hasNoCurve = noRiskCurveEndStates.includes(endState[0]);
        const acresXY = [
            Object.keys(riskCurves.acres).map((key) => riskCurves.acres[key][0]),
            Object.keys(riskCurves.acres).map((key) => hasNoCurve ? 0 : riskCurves.acres[key][1] * probability)
        ];
        const buildingImpactedXY = [
            Object.keys(riskCurves.building_impact).map((key) => riskCurves.building_impact[key][0]),
            Object.keys(riskCurves.building_impact).map((key) => hasNoCurve ? 0 : riskCurves.building_impact[key][1] * probability)
        ];
        const populationImpactedXY = [
            Object.keys(riskCurves.population_impact).map((key) => riskCurves.population_impact[key][0]),
            Object.keys(riskCurves.population_impact).map((key) => hasNoCurve ? 0 : riskCurves.population_impact[key][1] * probability)
        ];
        const dialog = (
            <Dialog
                fullWidth
                maxWidth={false}
                open={true}
                onClose={() => this.setState({dialog: null})}
                classes={{paper: classes.root}}
            >
                <DialogTitle>
                    {`Risk Curves - ${title}`}
                    <IconButton aria-label="close" className={classes.closeButton}
                                onClick={() => this.setState({dialog: null})}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <RiskCurvesContent
                        acresXY={acresXY}
                        buildingImpactedXY={buildingImpactedXY}
                        populationImpactedXY={populationImpactedXY}
                    />
                </DialogContent>
            </Dialog>
        );
        this.setState({dialog});
    };

    // return the data for the cutset table of a single end state, given two lists of results from that
    public compareCutsets(cutsetsA, cutsetsB) {
        let tableData = new Map();

        //populate map with A's data, leaving spots for B
        cutsetsA.forEach((cutsetData) => {
            this[JSON.stringify(cutsetData.cutset)] = {
                cutset: cutsetData.cutset,
                rankA: cutsetData.rank,
                rankB: null,
                probA: cutsetData.probability,
                probB: null,
            }
        }, this);

        //TODO populate B's cutsets for this endstate

        return tableData;
    };

    // return the data for the cutset table of a single end state, given two lists of results from that
    public compareEndStates(seqA, seqB) {
        let tableData = new Map();
        const arrA = Object.entries(seqA);
        const arrB = Object.entries(seqB);

        //populate map with A's data, leaving spots for B
        arrA.forEach((entry) => {
            tableData.set(entry[0], {
                endstate: entry[0],
                resultA: entry[1].result,
                resultB: null,
                cutsetsA: entry[1].cutsets,
                cutsetsB: null,
                cutsetComparison: null,
            });
        });

        //go through B's data, and populate missing data
        arrB.forEach((entry) => {
            let tableEntry = tableData.get(entry[0]);
            if (tableEntry) {
                tableEntry.resultB = entry[1].result;
                tableEntry.cutsetsB = entry[1].cutsets;
                //TODO add cutsets comparison field here
            } else {
                tableData.set(entry[0], {
                    endstate: entry[0],
                    resultA: null,
                    resultB: entry[1].result,
                    cutsetsA: null,
                    cutsetsB: entry[1].cutsets,
                    cutsetComparison: null,
                });
            }
        });
        return Array.from(tableData.values());
    };

    public render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        const {loading, classes, loadingText, noDataText, resultDataA, resultDataB, intl} = this.props;
        const {dialog} = this.state;

        const compData = this.compareEndStates(resultDataA.sequences, resultDataB.sequences);

        let content;
        if (loading) {
            content = loadingText;
        } else if (isCutsetEmpty(resultDataA) && isCutsetEmpty(resultDataB)) {
            content = noDataText;
        } else {
            content = (
                <ReactTable
                    data={compData}
                    noDataText={intl.formatMessage({id: 'FaultTreeResultView.table.no_result'})}
                    columns={this.getEndStateColumns()}
                    defaultPageSize={10}
                    style={{height: '100%'}}
                    className="-striped -highlight"
                    SubComponent={(row: any) => {
                        const data = row.original.cutsetsA.map((cutsetA) => {
                            return {
                                before: {...cutsetA},
                                after: row.original.cutsetsB.find((cutsetB) => _.isEqual(cutsetB.cutset[0], cutsetA.cutset[0])),
                                endstate: row.original.endstate
                            }
                        }).sort((a,b) => a.after.ranking > b.after.ranking);
                        return (
                            <div className={classes.subcomponent}>
                                <ReactTable
                                  data={data}
                                  noDataText={intl.formatMessage({ id: 'FaultTreeResultView.table.no_result' })}
                                  columns={this.getCutsetColumns()}
                                  defaultPageSize={5}
                                  className="-striped -highlight"
                                />
                            </div>
                        );
                    }}
                />
            );
        }
        return (
            <div className={classes.root}>
                {content}
                {dialog}
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(injectIntl(CutsetComparisonView));
